"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _UnreachableCaseError = require("@oberoninternal/travelbase-ds/entities/UnreachableCaseError");
var _graphql = require("../generated/graphql");
const getTargetAudienceMessage = (targetAudience, intl) => {
  switch (targetAudience) {
    case _graphql.TargetAudienceEnum.AllAges:
      return intl.formatMessage({
        "id": "6rzOy/",
        "defaultMessage": [{
          "type": 0,
          "value": "alle leeftijden"
        }]
      });
    case _graphql.TargetAudienceEnum.Adults:
      return intl.formatMessage({
        "id": "VInLTi",
        "defaultMessage": [{
          "type": 0,
          "value": "volwassenen"
        }]
      });
    case _graphql.TargetAudienceEnum.Children:
      return intl.formatMessage({
        "id": "AkwbVe",
        "defaultMessage": [{
          "type": 0,
          "value": "kinderen"
        }]
      });
    case _graphql.TargetAudienceEnum.WheelchairAccessible:
      return intl.formatMessage({
        "id": "ld2Krt",
        "defaultMessage": [{
          "type": 0,
          "value": "rolstoelvriendelijk"
        }]
      });
    case _graphql.TargetAudienceEnum.Pets:
      return intl.formatMessage({
        "id": "CJuOrp",
        "defaultMessage": [{
          "type": 0,
          "value": "huisdieren"
        }]
      });
    default:
      throw new _UnreachableCaseError.UnreachableCaseError(targetAudience);
  }
};
var _default = exports.default = getTargetAudienceMessage;